module.exports = __webpack_public_path__ + "img/4-3.6a1d26fa.svg";